// src/js/actions/index.js
import * as types from "../constants/action-types";
import RegisterApi from "../api/registerApi";
import { beginAjaxCall, errorAjaxCall } from "./ajaxStatus";

//export function loadRegisterSuccess(register) { return { type: types.LOAD_REGISTER_SUCCESS, register }};
export function loadRegisterWeeklyHistorySuccess(history) {
  return { type: types.LOAD_WEEKLY_REGISTER_HISTORY_SUCCESS, history };
}
export function loadSignInSuccess(register) {
  return { type: types.LOAD_SIGNIN_SUCCESS, register };
}
export function signInSuccess(register) {
  return { type: types.SIGNIN_SUCCESS, register };
}
export function signOutSuccess(register) {
  return { type: types.SIGNOUT_SUCCESS, register };
}
export function signOutAllSuccess(register) {
  return { type: types.SIGNOUTALL_SUCCESS, register };
}
export function loadSignInPersonnelSuccess(person) {
  return { type: types.LOAD_SIGNINPERSONNEL_SUCCESS, person };
}
export function updatePersonnelSuccess(personnel) {
  return { type: types.UPDATE_PERSONNEL_SUCCESS, personnel };
}
export function createPersonnelSuccess(personnel) {
  return { type: types.CREATE_PERSONNEL_SUCCESS, personnel };
}
export function getPersonnelSuccess(personnel) {
  return { type: types.GET_PERSONNEL_SUCCESS, personnel };
}
export function loadPersonnelSuccess(personnel) {
  return { type: types.LOAD_PERSONNEL_SUCCESS, personnel };
}
export function clearPersonnelCardReaderState(personnel) {
  return { type: types.CLEAR_PERSONNEL_CARDREADER, personnel };
}
export function loadCollarsSuccess(collars) {
  return { type: types.LOAD_COLLAR_SUCCESS, collars };
}
export function loadFieldSchemaSuccess(schema) {
  return { type: types.LOAD_FIELD_SCHEMA_SUCCESS, schema };
}

export function loadRaceCardSuccess(racecard) {
  return { type: types.LOAD_RACECARD_SUCCESS, racecard };
}
export function loadRegisterLocationSuccess(location) {
  return { type: types.LOAD_REGISTER_LOCATION_SUCCESS, location };
}
export function updateSignInLocationsSuccess(location) {
  return { type: types.UPDATE_REGISTER_LOCATION_SUCCESS, location };
}
export function deleteSignInLocationsSuccess(location) {
  return { type: types.DELETE_REGISTER_LOCATION_SUCCESS, location };
}
export function createSignInLocationsSuccess(location) {
  return { type: types.CREATE_REGISTER_LOCATION_SUCCESS, location };
}
export function getSignInLocationSuccess(location) {
  return { type: types.GET_REGISTER_LOCATION_SUCCESS, location };
}

export function loadRegisterSummarySuccess(register) {
  return { type: types.LOAD_REGISTER_SUMMARY_SUCCESS, register };
}
export function loadPersonnelByCardSuccess(personnel) {
  return { type: types.LOAD_CARD_PERSONNEL_SUCCESS, personnel };
}
export function loadRegisterlogSuccess(registerlogs) {
  return { type: types.LOAD_REGISTER_LOG_SUCCESS, registerlogs };
}
export function updateRegisterlogsSuccess(registerlog) {
  return { type: types.UPDATE_REGISTER_LOG_SUCCESS, registerlog };
}
export function deleteRegisterlogsSuccess(registerlog) {
  return { type: types.DELETE_REGISTER_LOG_SUCCESS, registerlog };
}
export function deleteRegisterAccidentSuccess(accidentId) {
  return { type: types.DELETE_REGISTER_ACCIDENT_SUCCESS, accidentId };
}
export function deleteRegisterFileSuccess(fileEntryId) {
  return { type: types.DELETE_REGISTER_FILE_SUCCESS, fileEntryId };
}
export function getRegisterLogSuccess(registerlog) {
  return { type: types.GET_REGISTER_LOG_SUCCESS, registerlog };
}

export function loadPostcodesSuccess(postcodes) {
  return { type: types.LOAD_POSTCODES_SUCCESS, postcodes };
}

export function loadLocation(include) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    return RegisterApi.getLocation(include)
      .then((location) => {
        console.log("success: loadLocation");
        dispatch(loadRegisterLocationSuccess(location.data));
      })
      .catch((error) => {
        console.log("error: loadLocation");
        dispatch(errorAjaxCall());
        throw error;
      });
  };
}

export function loadPersonnelSearchList(name) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    return RegisterApi.GetPersonnelSearchList(name)
      .then((personnel) => {
        console.log(JSON.stringify(personnel.data));
        console.log("success: loadPersonnelSearchList", personnel.data);
        dispatch(loadPersonnelSuccess(personnel.data));
      })
      .catch((error) => {
        console.log("error: loadPersonnelSearchList");
        dispatch(errorAjaxCall());
        throw error;
      });
  };
}

export function loadFieldSchema(path) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    return RegisterApi.getFieldSchema(path)
      .then((schema) => {
        console.log("success: loadFieldSchema");
        dispatch(loadFieldSchemaSuccess(schema.data));
      })
      .catch((error) => {
        console.log("error: loadFieldSchema");
        dispatch(errorAjaxCall());
        throw error;
      });
  };
}

export function loadRaceCard(i) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    return RegisterApi.getRaceCard(i)
      .then((racecard) => {
        console.log("success: loadRaceCard");
        dispatch(loadRaceCardSuccess(racecard));
      })
      .catch((error) => {
        console.log("error: loadRaceCard");
        dispatch(errorAjaxCall());
        throw error;
      });
  };
}

export function loadRegisterWeeklyHistory() {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    return RegisterApi.getRegisterWeeklyHistory()
      .then((register) => {
        console.log("success: loadRegisterWeeklyHistory");
        dispatch(loadRegisterWeeklyHistorySuccess(register.data));
      })
      .catch((error) => {
        console.log("error: loadRegisterWeeklyHistory");
        dispatch(errorAjaxCall());
        throw error;
      });
  };
}

export function loadPostcodes() {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    return RegisterApi.getPostcodes()
      .then((postcodes) => {
        dispatch(loadPostcodesSuccess(postcodes.data));
      })
      .catch((error) => {
        dispatch(errorAjaxCall());
        throw error;
      });
  };
}

export function loadRegisterSummary() {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    return RegisterApi.getRegisterCount()
      .then((register) => {
        console.log("success: loadRegisterSummary");
        dispatch(loadRegisterSummarySuccess(register.data));
      })
      .catch((error) => {
        console.log("error: loadRegisterSummary");
        dispatch(errorAjaxCall());
        throw error;
      });
  };
}

export function loadSignInNoDB(i) {
  return function (dispatch) {
    dispatch(loadSignInSuccess(i));
  };
}

export function loadSignIn(i) {
  return function (dispatch) {
    console.log(i);
    //to clear cached selected register check if params are 0, 0
    if (i == 0) {
      dispatch(loadSignInSuccess({}));
    } else {
      dispatch(beginAjaxCall());
      return RegisterApi.getRegisterById(i)
        .then((register) => {
          console.log("success: loadSignIn");
          dispatch(loadSignInSuccess(register.data));
        })
        .catch((error) => {
          console.log("error: loadSignIn");
          dispatch(errorAjaxCall());
          throw error;
        });
    }
  };
}

export function getPersonnel(id) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    return RegisterApi.getPersonnelById(id)
      .then((personnel) => {
        dispatch(getPersonnelSuccess(personnel.data));
      })
      .catch((error) => {
        console.log("error: getPersonnel(id)");
        dispatch(errorAjaxCall());
        throw error;
      });
  };
}

export function getRegisterLog(id) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    return RegisterApi.getRegisterLogById(id)
      .then((log) => {
        dispatch(getRegisterLogSuccess(log.data));
      })
      .catch((error) => {
        dispatch(errorAjaxCall());
        throw error;
      });
  };
}

export function signIn(obj, update) {
  let status = update || "SignIn";
  return function (dispatch, getState) {
    dispatch(beginAjaxCall());
    return RegisterApi.saveRegister(obj, status)
      .then((register) => {
        console.log("success: signIn");
        dispatch(signInSuccess(register.data));
        console.log("sign in reducer finished");
      })
      .catch((error) => {
        console.log("error: signIn");
        dispatch(errorAjaxCall());
        throw error;
      });
  };
}

export function signOut(obj) {
  return function (dispatch, getState) {
    dispatch(beginAjaxCall());
    return RegisterApi.saveRegister(obj, "SignOut")
      .then((register) => {
        console.log("success: signOut");
        dispatch(signOutSuccess(register.data));
        console.log("sign out reducer finished");
      })
      .catch((error) => {
        console.log("error: signOut");
        dispatch(errorAjaxCall());
        throw error;
      });
  };
}

export function signOutAll(obj) {
  return function (dispatch, getState) {
    dispatch(beginAjaxCall());
    return RegisterApi.saveRegisterAll(obj, "SignOut")
      .then((register) => {
        //dispatch(signOutAllSuccess(register.data));
        console.log("sign out all reducer finished");
      })
      .catch((error) => {
        console.log("error: signOutAll");
        dispatch(errorAjaxCall());
        throw error;
      });
  };
}

export function clearPersonnelCardReader() {
  return function (dispatch, getState) {
    dispatch(clearPersonnelCardReaderState());
  };
}

export function loadRegisterHistory(registerId) {
  return function (dispatch, getState) {
    dispatch(beginAjaxCall());
    return RegisterApi.GetSignInHistory(registerId)
      .then((person) => {
        dispatch(loadSignInSuccess(person.data));
      })
      .catch((error) => {
        console.log("error: loadRegisterHistory");
        dispatch(errorAjaxCall());
        throw error;
      });
  };
}

export function loadSignInPersonnel(name, reference) {
  return function (dispatch, getState) {
    if (name == "" && reference == "") {
      dispatch(loadSignInPersonnelSuccess({}));
    } else {
      dispatch(beginAjaxCall());
      return RegisterApi.getSignInPersonnel(name, reference)
        .then((person) => {
          console.log("success: loadSignInPersonnel");
          console.log(person.data);
          if (person.data.length == 1) {
            dispatch(loadSignInSuccess(person.data));
          } else {
            dispatch(loadSignInPersonnelSuccess(person.data));
          }
          console.log("load sign in personnel reducer finished");
        })
        .catch((error) => {
          console.log("error: loadSignInPersonnel");
          dispatch(errorAjaxCall());
          throw error;
        });
    }
  };
}

export function savePersonnel(obj) {
  return function (dispatch, getState) {
    dispatch(beginAjaxCall());
    return RegisterApi.savePersonnel(obj)
      .then((personnel) => {
        console.log("success: savePersonnel");
        personnel.data.personnelId > 0
          ? dispatch(updatePersonnelSuccess(personnel.data))
          : dispatch(createPersonnelSuccess(personnel.data));
      })
      .catch((error) => {
        console.log("error: savePersonnel");
        dispatch(errorAjaxCall());
        throw error;
      });
  };
}

export function updatePersonnel(obj) {
  return function (dispatch, getState) {
    dispatch(beginAjaxCall());

    obj.personnelId > 0
      ? dispatch(updatePersonnelSuccess(obj))
      : dispatch(createPersonnelSuccess(obj));
  };
}

export function loadRegisterLogs(i) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    return RegisterApi.getRegisterLogById(i)
      .then((registerlogs) => {
        console.log("success: loadRegisterlogs");
        dispatch(loadRegisterlogSuccess(registerlogs.data));
      })
      .catch((error) => {
        console.log("error: loadRegisterlogs");
        dispatch(errorAjaxCall());
        throw error;
      });
  };
}

export function loadCollars() {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    return RegisterApi.getCollars()
      .then((collar) => {
        console.log(collar);
        dispatch(loadCollarsSuccess(collar.data));
      })
      .catch((error) => {
        dispatch(errorAjaxCall());
        throw error;
      });
  };
}

export function saveRegisterLog(obj) {
  return function (dispatch, getState) {
    dispatch(beginAjaxCall());
    return RegisterApi.saveRegisterLog(obj)
      .then((registerlog) => {
        console.log("success: saveRegisterLog");
        dispatch(updateRegisterlogsSuccess(registerlog.data));
        return registerlog.data;
      })
      .catch((error) => {
        console.log("error: saveRegisterLog");
        dispatch(errorAjaxCall());
        throw error;
      });
  };
}

export function deleteRegisterLog(id) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    return RegisterApi.deleteRegisterLog(id)
      .then(function () {
        console.log("success: deleteRegisterlog");
        dispatch(deleteRegisterlogsSuccess(id));
      })
      .catch((error) => {
        console.log("error: deleteRegisterlog");
        dispatch(errorAjaxCall());
        throw error;
      });
  };
}

export function saveSignInLocation(obj) {
  return function (dispatch, getState) {
    dispatch(beginAjaxCall());
    return RegisterApi.saveSignInLocation(obj)
      .then((signInLocation) => {
        console.log("success: saveSignInLocation");
        dispatch(updateSignInLocationsSuccess(signInLocation.data));
      })
      .catch((error) => {
        console.log("error: saveSignInLocation");
        dispatch(errorAjaxCall());
        throw error;
      });
  };
}

export function deleteSignInLocation(id) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    return RegisterApi.deleteSignInLocation(id)
      .then(function () {
        console.log("success: deleteSignInLocation");
        dispatch(deleteSignInLocationsSuccess(id));
      })
      .catch((error) => {
        console.log("error: deleteSignInLocation");
        dispatch(errorAjaxCall());
        throw error;
      });
  };
}

export function getSignInLocation(id) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    return RegisterApi.getSignInLocation(id)
      .then((location) => {
        dispatch(getSignInLocationSuccess(location.data));
      })
      .catch((error) => {
        dispatch(errorAjaxCall());
        throw error;
      });
  };
}

export function saveRegisterAccident(i, obj) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    return RegisterApi.saveRegisterAccident(obj)
      .then((registerAccident) => {
        console.log("success: saveRegisterAccident");
        dispatch(loadRegisterLogs(i));
      })
      .catch((error) => {
        console.log("error: saveRegisterAccident");
        dispatch(errorAjaxCall());
        throw error;
      });
  };
}

export function deleteRegisterAccident(id) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    return RegisterApi.deleteRegisterAccident(id)
      .then(function () {
        console.log("success: deleteRegisterAccident");
        dispatch(deleteRegisterAccidentSuccess(id));
      })
      .catch((error) => {
        console.log("error: deleteRegisterAccident");
        dispatch(errorAjaxCall());
        throw error;
      });
  };
}

export function deleteRegisterFile(id) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    return RegisterApi.deleteRegisterFile(id)
      .then(function () {
        console.log("success: deleteRegisterFile");
        dispatch(deleteRegisterFileSuccess(id));
      })
      .catch((error) => {
        console.log("error: deleteRegisterFile");
        dispatch(errorAjaxCall());
        throw error;
      });
  };
}

//socket-io functions

export function disconnect() {
  var t = document.getElementsByClassName("tooltip")[0];
  if (t) t.parentElement.removeChild(t);

  return {
    type: "socket",
    types: [
      types.DISCONNECT_REQUEST,
      types.DISCONNECT_SUCCESS,
      types.DISCONNECT_FAILURE,
    ],
    promise: (socket) => socket.disconnect(),
  };
}

export function connect() {
  return {
    type: "socket",
    types: [
      types.CONNECT_REQUEST,
      types.CONNECT_SUCCESS,
      types.CONNECT_FAILURE,
    ],
    promise: (socket) => socket.connect(),
  };
}

export function send(content) {
  const message = { content };
  console.log("sending message", message);
  return {
    type: "socket",
    types: [types.SEND_REQUEST, types.SEND_SUCCESS, types.SEND_FAILURE],
    promise: (socket) => socket.emit("message", message),
  };
}

export function card_sync(content) {
  return {
    type: "socket",
    types: [types.CARD_Q_REQUEST, types.CARD_Q_SUCCESS, types.CARD_Q_FAILURE],
    promise: (socket) => socket.emit("card_sync", content),
  };
}

export function card_success(cb) {
  return {
    type: "socket",
    types: [types.CARD_S_REQUEST, types.CARD_S_SUCCESS, types.CARD_S_FAILURE],
    promise: (socket) => socket.on("card_success", cb),
  };
}

export function card_failed(cb) {
  return {
    type: "socket",
    types: [types.CARD_F_REQUEST, types.CARD_F_SUCCESS, types.CARD_F_FAILURE],
    promise: (socket) => socket.on("card_failed", cb),
  };
}

export function receive(cb) {
  return {
    type: "socket",
    types: [
      types.RECEIVE_REQUEST,
      types.RECEIVE_SUCCESS,
      types.RECEIVE_FAILURE,
    ],
    promise: (socket) => socket.on("receive", cb),
  };
}
